import React from 'react'
import PropTypes from 'prop-types'

const styles = {
    col1: {
        fill: '#fff',
        fillRule: 'nonzero',
    },
}

const entranceAiSVG = ({ classes, color, width, height }) => (
    <svg viewBox="0 0 732 732" width={width} height={height}>
        <g>
            <polygon style={styles.col1}
                     points="578,154 578,0 0,0 0,424 578,424 578,270 546,270 546,392 31,392 31,31 546,31 546,154 "/>
        </g>
        <polygon style={{ fill: color }}
                 points="417,193 417,125 267,211 417,298 417,231 693,231 693,514 732,514 732,193 "/>
        <g>
            <polygon style={{ fill: color }} points="327,709 308,709 308,529 327,529 "/>
            <g>
                <polygon style={{ fill: color }} points="19,633 0,633 0,578 19,578 "/>
                <polygon style={{ fill: color }} points="38,651 19,651 19,560 38,560 "/>
                <polygon style={{ fill: color }} points="58,660 38,660 38,551 58,551 "/>
                <polygon style={{ fill: color }} points="77,669 58,669 58,542 77,542 "/>
                <polygon style={{ fill: color }} points="96,696 77,696 77,515 96,515 "/>
                <polygon style={{ fill: color }} points="116,633 96,633 96,578 116,578 "/>
                <polygon style={{ fill: color }} points="135,624 116,624 116,588 135,588 "/>
                <polygon style={{ fill: color }} points="154,633 135,633 135,578 154,578 "/>
                <polygon style={{ fill: color }} points="173,642 154,642 154,569 173,569 "/>
                <polygon style={{ fill: color }} points="193,669 173,669 173,542 193,542 "/>
                <polygon style={{ fill: color }} points="212,732 193,732 193,507 212,507 "/>
                <polygon style={{ fill: color }} points="231,696 212,696 212,515 231,515 "/>
                <polygon style={{ fill: color }} points="289,660 270,660 270,551 289,551 "/>
                <polygon style={{ fill: color }} points="308,669 289,669 289,542 308,542 "/>
                <polygon style={{ fill: color }} points="250,633 231,633 231,578 250,578 "/>
                <polygon style={{ fill: color }} points="270,624 250,624 250,588 270,588 "/>
                <polygon style={{ fill: color }} points="347,633 327,633 327,578 347,578 "/>
                <polygon style={{ fill: color }} points="366,651 347,651 347,560 366,560 "/>
                <polygon style={{ fill: color }} points="385,660 366,660 366,551 385,551 "/>
                <polygon style={{ fill: color }} points="404,714 385,714 385,525 404,525 "/>
                <polygon style={{ fill: color }} points="424,696 404,696 404,515 424,515 "/>
                <polygon style={{ fill: color }} points="443,633 424,633 424,578 443,578 "/>
                <polygon style={{ fill: color }} points="462,624 443,624 443,588 462,588 "/>
                <polygon style={{ fill: color }} points="481,633 462,633 462,578 481,578 "/>
                <polygon style={{ fill: color }} points="501,642 481,642 481,569 501,569 "/>
                <polygon style={{ fill: color }} points="520,669 501,669 501,542 520,542 "/>
                <polygon style={{ fill: color }} points="539,714 520,714 520,525 539,525 "/>
                <polygon style={{ fill: color }} points="558,696 539,696 539,515 558,515 "/>
                <polygon style={{ fill: color }} points="578,633 558,633 558,578 578,578 "/>
                <polygon style={{ fill: color }} points="597,624 578,624 578,588 597,588 "/>
                <polygon style={{ fill: color }} points="616,651 597,651 597,560 616,560 "/>
                <polygon style={{ fill: color }} points="635,660 616,660 616,551 635,551 "/>
                <polygon style={{ fill: color }} points="655,696 635,696 635,515 655,515 "/>
                <polygon style={{ fill: color }} points="674,678 655,678 655,533 674,533 "/>
                <polygon style={{ fill: color }} points="693,633 674,633 674,578 693,578 "/>
                <polygon style={{ fill: color }} points="712,624 693,624 693,588 712,588 "/>
                <polygon style={{ fill: color }} points="732,615 712,615 712,597 732,597 "/>
            </g>
        </g>
    </svg>
)

entranceAiSVG.defaultProps = {
    color: '#8AC43F',
    width: 24,
    height: 24,
}

entranceAiSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default entranceAiSVG
